import React from 'react';
import AddressesMapView from '../quota/components/AddressesMapView';

/** Supervisor's own location addresses across all their projects. */
const SupervisorAddressesMap = () => (
  <AddressesMapView
    endpoint="/quotas/my-addresses"
    allowVisitedToggle
    title="Carte des adresses"
    subtitle="Tous vos emplacements à visiter, tous projets confondus."
  />
);

export default SupervisorAddressesMap;
